import React from 'react';
import { Home, MapPin, Star, Clock, CheckSquare } from 'lucide-react';
export function TrustBar() {
  const trustItems = [{
    icon: <Home size={24} className="text-accent" data-id="element-251" />,
    title: 'COMPLETE',
    subtitle: 'EXTERIOR SERVICES'
  }, {
    icon: <MapPin size={24} className="text-accent" data-id="element-252" />,
    title: 'SERVING',
    subtitle: 'SAN DIEGO COUNTY'
  }, {
    icon: <Star size={24} className="text-accent" data-id="element-253" />,
    title: 'TOP-RATED',
    subtitle: 'LOCAL TEAM'
  }, {
    icon: <Clock size={24} className="text-accent" data-id="element-254" />,
    title: 'FAST',
    subtitle: 'RESPONSE'
  }, {
    icon: <CheckSquare size={24} className="text-accent" data-id="element-255" />,
    title: 'FREE',
    subtitle: 'ESTIMATES'
  }];
  return <div className="bg-darkCharcoal py-6 border-b-4 border-primary" data-id="element-256">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-257">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-6 md:gap-4" data-id="element-258">
          {trustItems.map((item, index) => <div key={index} className={`flex flex-col items-center text-center ${index === 4 ? 'col-span-2 md:col-span-1' : ''}`} data-id="element-259">
              <div className="mb-2" data-id="element-260">{item.icon}</div>
              <span className="text-white font-bold text-sm tracking-wide" data-id="element-261">
                {item.title}
              </span>
              <span className="text-gray-400 text-xs mt-0.5" data-id="element-262">
                {item.subtitle}
              </span>
            </div>)}
        </div>
      </div>
    </div>;
}